import React from "react";
import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 24, className = "", as = "div" }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease, delay }}
    >
      {children}
    </MotionTag>
  );
};

export const Stagger = ({ children, className = "", delayStep = 0.08 }) => (
  <div className={className}>
    {React.Children.map(children, (child, i) => (
      <Reveal delay={i * delayStep}>{child}</Reveal>
    ))}
  </div>
);
